module.exports = __webpack_public_path__ + "img/drone-lazy.bfda92d4.jpg";